import * as Token from './Token';
const color = Object.assign({}, Token.color, { brand: Token.color.brandGodwitBlue, tintPrimary: Token.color.uiBluePrimary, tintSecondary: Token.color.uiBlueSecondary, tintDark: Token.color.uiBlueDark, tintLight: Token.color.uiBlueLight, accentPrimary: Token.color.uiOrangePrimary, accentSecondary: Token.color.uiOrangeSecondary, accentDark: Token.color.uiOrangeDark, accentLight: Token.color.uiOrangeLight, lightPrimary: Token.color.uiLightPrimary, lightStain: Token.color.uiLightStain, lightNeutral: Token.color.uiLightNeutral, lightSecondary: Token.color.uiLightSecondary, darkPrimary: Token.color.uiDarkPrimary, darkStain: Token.color.uiDarkStain, darkNeutral: Token.color.uiDarkNeutral, darkSecondary: Token.color.uiDarkSecondary, textHighlight: Token.color.uiBlueDark, textAlert: Token.color.uiRedDark, textWarning: Token.color.uiYellowDark, textPositive: Token.color.uiGreenDark, textPrice: Token.color.uiOrangePrimary, textPrimary: Token.color.uiDarkPrimary, textSecondary: Token.color.uiDarkSecondary, textMuted: Token.color.uiLightSecondary, textPrimaryInteractive: Token.color.uiBluePrimary, textDestructiveInteractive: Token.color.uiRedDark, textWhite: Token.color.uiLightPrimary, borderSubtle: Token.color.uiLightNeutral, borderDivide: Token.color.uiLightSecondary });
// --------------------------------------
export { color };
// will deprecate
export const buttonBgColorPrimary = {
    active: Token.color.uiBluePrimary,
    pressed: Token.color.uiBluePrimary,
    disabled: Token.color.uiLightNeutral,
};
export const buttonTextColorPrimary = {
    active: Token.color.uiLightPrimary,
    pressed: Token.color.uiLightPrimary,
    disabled: Token.color.uiLightSecondary,
};
export const buttonBgColorSecondary = {
    active: Token.color.uiLightStain,
    pressed: Token.color.uiLightStain,
    disabled: Token.color.uiLightNeutral,
};
export const buttonTextColorSecondary = {
    active: Token.color.uiBluePrimary,
    pressed: Token.color.uiBluePrimary,
    disabled: Token.color.uiLightSecondary,
};
export const buttonBgColorMainCta = {
    active: Token.color.uiOrangePrimary,
    pressed: Token.color.uiOrangePrimary,
    disabled: Token.color.uiLightNeutral,
};
export const buttonTextColorMainCta = {
    active: Token.color.uiLightPrimary,
    pressed: Token.color.uiLightPrimary,
    disabled: Token.color.uiLightSecondary,
};
export const buttonTransparentColor = {
    active: 'transparent',
    pressed: 'transparent',
    disabled: 'transparent',
};
export const buttonTextColorText = {
    active: Token.color.uiBluePrimary,
    pressed: Token.color.uiBluePrimary,
    disabled: Token.color.uiLightSecondary,
};
export const buttonTextColorTextBlack = {
    active: Token.color.uiDarkNeutral,
    pressed: Token.color.uiDarkNeutral,
    disabled: Token.color.uiLightSecondary,
};
export const buttonTextColorTextWhite = {
    active: Token.color.uiLightPrimary,
    pressed: Token.color.uiLightPrimary,
    disabled: Token.color.uiLightSecondary,
};
export const buttonTextColorTextDestructive = {
    active: Token.color.uiRedPrimary,
    pressed: Token.color.uiRedPrimary,
    disabled: Token.color.uiLightSecondary,
};
export const buttonTextOutlineBlack = {
    active: Token.color.uiDarkNeutral,
    pressed: Token.color.uiDarkNeutral,
    disabled: Token.color.uiLightSecondary,
};
export const buttonBorderOutlineBlack = {
    active: Token.opacity.opaque(Token.color.uiDarkNeutral),
    pressed: Token.opacity.opaque(Token.color.uiDarkNeutral),
    disabled: Token.opacity.opaque(Token.color.uiLightSecondary),
};
export const buttonTextOutlineWhite = {
    active: Token.color.uiLightNeutral,
    pressed: Token.color.uiLightNeutral,
    disabled: Token.color.uiDarkSecondary,
};
export const buttonBorderOutlineWhite = {
    active: Token.opacity.opaque(Token.color.uiLightNeutral),
    pressed: Token.opacity.opaque(Token.color.uiLightNeutral),
    disabled: Token.opacity.opaque(Token.color.uiDarkSecondary),
};
export const buttonBgColorDestructivePrimary = {
    active: Token.color.uiRedPrimary,
    pressed: Token.color.uiRedPrimary,
    disabled: Token.color.uiLightNeutral,
};
export const buttonTextColorDestructivePrimary = {
    active: Token.color.uiLightPrimary,
    pressed: Token.color.uiLightPrimary,
    disabled: Token.color.uiLightSecondary,
};
export const buttonBgColorDestructiveSecondary = {
    active: Token.color.uiLightStain,
    pressed: Token.color.uiLightStain,
    disabled: Token.color.uiLightNeutral,
};
export const buttonTextColorDestructiveSecondary = {
    active: Token.color.uiRedPrimary,
    pressed: Token.color.uiRedPrimary,
    disabled: Token.color.uiLightSecondary,
};
